import { t } from 'i18next';
import { ThumbnailPhotoCard } from '@peacecover/component';
import ChatList from './ChatList';
import type { SaleTradingPhotoCardType } from '../types/MarketCardType';

interface TradingPhotoCardItemProps {
  tradingPhotoCard: SaleTradingPhotoCardType;
}

const TradingPhotoCardItem = ({ tradingPhotoCard }: TradingPhotoCardItemProps) => {
  const eventCategory = tradingPhotoCard.photoCard.eventCategory;
  const category = tradingPhotoCard.photoCard.category;
  return (
    <div className="w-full rounded-[16px] bg-background-light dark:bg-background-dark pb-[4px] border border-separator1 dark:border-[#141414] shadow-[0_4px_10px_0_rgba(0,0,0,0.04),0_0_24px_0_rgba(255,255,255,0.30)_inset] backdrop-blur-[20px] dark:shadow-[0_0_3px_0_rgba(0,0,0,0.83),0_0_12px_0_#000]">
      <div className="flex flex-row items-center justify-between p-[16px] shadow-[inset_0_-1px_0_0_var(--color-separator1)] dark:shadow-[inset_0_-1px_0_0_var(--color-separator2)]">
        <div className="flex flex-row gap-[8px]">
          <ThumbnailPhotoCard
            imageUrl={
              tradingPhotoCard.photoCard.mediumThumbnailUrl || tradingPhotoCard.photoCard.pictureUrl
            }
            size="small"
            className="w-[29px] h-[46px] rounded-[4px]"
          />
          <div className="flex flex-col gap-[5px] leading-none justify-center">
            <p className="h-[14px] text-[12px] font-bold text-on-label">
              {t('NewTradingPhotoCardMarket.photoCardTitle', {
                artist: tradingPhotoCard.photoCard.memberName,
                category: t(`PhotoCardCategory.${eventCategory}.${category}.text`)
              })}
            </p>
            <p className="h-[13px] text-[11px] text-text-sub-lv1">{tradingPhotoCard.eventName}</p>
          </div>
        </div>
        <div className="flex flex-col gap-[3px] items-end">
          <div
            className={`px-[5px] rounded-[20px] py-[2px] text-[9px] font-semibold ${tradingPhotoCard.status === 'pending' ? 'bg-success text-on-success' : 'bg-surface-lv2 text-text-sub-lv1'}`}
          >
            {tradingPhotoCard.status === 'pending' || tradingPhotoCard.status === 'ongoing'
              ? t('NewTradingPhotoCardMarket.exchangeStatus.pending')
              : t('NewTradingPhotoCardMarket.exchangeStatus.completed')}
          </div>
          <p className="text-[15px] font-semibold text-text-primary">
            {tradingPhotoCard.price ?? t('NewTradingPhotoCardMarket.offerPrice')}
          </p>
        </div>
      </div>
      <div>
        <ChatList tradingPhotoCard={tradingPhotoCard} />
      </div>
    </div>
  );
};

export default TradingPhotoCardItem;
